module.exports = __webpack_public_path__ + "static/ntt2-01-c442fe3f2c5e0073a6d43bdc21e43da9.jpg";